'use client'
import {
  Headline,
  Subheadline,
  Container,
  ContentWrapper,
  CTAContainer
} from '@/components/ui'
import { CTAButton } from '@/components/ui/cta-button'
import MediaContainer from '@/components/ui/MediaContainer'
import GradientContainer from '@/components/ui/GradientContainer'
import { useCTAUrl } from '@/lib/use-cta-url'
import { useABTest } from '@/components/analytics/useABTest'
import { GradientVariant, HeadlineVariant } from '@/types/ui'
import { usePageSettings } from '@/components/contexts/PageSettingsContext'

interface InboxProps {
  gradientVariant?: GradientVariant
  headlineVariant?: HeadlineVariant
  title?: string
  subtitle?: string
}

const Inbox = ({ 
  gradientVariant = '11', 
  headlineVariant,
  title = "Smart inbox that works for you.",
  subtitle = "Your inbox automatically organizes, prioritizes, and transforms incoming information into actionable tasks."
}: InboxProps) => {
  const { enableInboxGoogleLogin, showGoogleLogoInbox } = usePageSettings()
  const {href: ctaUrl, isCalendly} = useCTAUrl()
  return (
      <Container variant="section">
        <ContentWrapper gap="lg">
          <Headline variant={headlineVariant}>{title}</Headline>
          <Subheadline htmlContent={true}>
            {subtitle}
          </Subheadline>
          
          <GradientContainer gradientVariant={gradientVariant} variant="fullscreen">
              <MediaContainer 
                src="/images/sections/1758547129107inbox.avif" 
                type="image"
                alt="Inbox Functions"
                className='md:max-w-[75%]'
              />
          </GradientContainer>
           
          {/* CTA Button */}
          <CTAContainer marginTop="sm">
            <CTAButton
              href={ctaUrl}
              variant="primary"
              size="lg"
              enableGoogleLogin={enableInboxGoogleLogin && !isCalendly}
              showGoogleLogo={showGoogleLogoInbox}
              external={ctaUrl.startsWith('http')}
            >
              Get Started
            </CTAButton>
          </CTAContainer>
        </ContentWrapper>
      </Container>
  )
}

export default Inbox
